module.exports = __webpack_public_path__ + "img/Yipi_AnimacionWeb_07_Ipad.b9e18097.gif";